import { PartialDoctorSignature } from "../../partials/doctorSignature";
import { PartialResponsibleSignature } from "../../partials/responsibleSignature";

export const termSurgeryConsent = {
  name: "Termo de Consentimento para Realização de Cirúrgia",
  title:
    "Termo de Consentimento Livre e Esclarecido para \nRealização de Procedimento Cirúrgico",
  gender: "male",
  fields: {
    procedure: {
      label: "Procedimento",
      type: "text",
      required: true,
      defaultPreview: _.range(20).fill("_").join(""),
    },
    microchip: {
      label: "Nº Microchip",
      type: "text",
      required: false,
    },
    identifications: {
      label: "Outras informações de identificação",
      type: "textarea",
      required: false,
      props: {
        rows: 2,
        style: { minWidth: "100%" },
      },
    },
    doctorName: {
      label: "Médico(a)/Veterinário(a)",
      type: "text",
      required: true,
      defaultPreview: _.range(20).fill("_").join(""),
    },
    doctorCRV: {
      label: "CRMV",
      type: "text",
      required: true,
      defaultPreview: _.range(5).fill("_").join(""),
    },
    risks: {
      label: "Riscos e Intercorrências do procedimento",
      type: "textarea",
      required: true,
      defaultPreview: _.range(50).fill("_").join(""),
      props: {
        rows: 4,
        style: { minWidth: "100%" },
      },
    },
  },
  partials: {
    doctorSignature: {
      defaultValue: true,
      partial: PartialDoctorSignature,
    },
    responsibleSignature: {
      defaultValue: true,
      partial: PartialResponsibleSignature,
    },
  },
  content: `
   <p>Autorizo a realização do procedimento cirúrgico <span>{{procedure}}</span> no animal identificado neste documento{{#microchip}}, nº do microchip: <span>{{microchip}}</span>{{/microchip}}{{#identifications}}, {{{identifications}}}{{/identifications}}, a ser realizado pelo(a) Médico(a) Veterinário(a) <span>{{doctorName}}</span>, CRMV-{{doctorCRV}}</p>
   <p>Declaro que foram prestados todos os esclarecimentos e informações relacionados ao procedimento pelo qual será submetido meu animal.</p>
   <p>Compreendo que o desempenho da atividade médica veterinária é de meio, portanto, embora empenhados todos os esforços, não há garantia de resultado de evolução favorável do quadro do paciente ou até mesmo a cura.</p>
   <p>Afirmo, portanto, conhecer sobre todas as etapas inerentes à realização do procedimento cirúrgico, principalmente quanto aos riscos e intercorrências, que embora de baixa incidência, são possíveis e do procedimento decorrentes, como por exemplo:</p>
   <p><span>{{{risks}}}</span>.</p>
   <p>Tenho ciência de que todo e qualquer procedimento médico veterinário necessário para a diligente assistência ao meu animal somente será realizado após a prestação das devidas explicações.</p>
   <p>Compreendo que os procedimentos caracterizados como urgência e emergência serão realizados a critério do médico veterinário responsável, ficando desde já autorizado.</p>
   <p>Confiro, ainda, o meu consentimento para realização de qualquer outro procedimento/ tratamento, diante ocorrência de situações imprevistas e que determinem a necessidade de cuidados diversos para resguardar a vida do animal.</p>
   <p>Tenho ciência, também, que para realização dos procedimentos poderá ser necessária a tricotomia do animal (raspagem do pelo), e que, dependendo da raça e do tipo de pele, o pelo pode demorar a crescer bem como não mais crescer no local, estando, portanto, o médico autorizado a fazer a tricotomia ainda assim.</p>
   <p>Declaro que o presente termo foi entregue com razoável antecedência, sendo dada a mim oportunidade para sanar eventuais dúvidas ou demais esclarecimentos sobre o atendimento do meu animal, sobre o ato cirúrgico e suas consequências.</p>
   <p>Afirmo, ainda, conhecer da revogabilidade do presente instrumento, ou seja, da possibilidade da retirada do meu consentimento, com desistência, após a assinatura do mesmo e antes do início do procedimento, da realização do ato cirúrgico.</p>
   <p>Finalmente, diante do recebimento de informações claras, precisas e adequadas acerca dos possíveis riscos inerentes, durante ou após a realização do ato cirúrgico citado, autorizo o procedimento, estando o profissional isento de quaisquer responsabilidades decorrentes de tais riscos.</p>

    {{#responsibleSignature}}
      <br />
      <br />
      <br />
      <br />
      <br />
      {{>responsibleSignature}}
    {{/responsibleSignature}}
    {{#doctorSignature}}
      <br />
      <br />
      <br />
      {{>doctorSignature}}
    {{/doctorSignature}}
  `.trim(),
};
